import Helpers from './common/helpers';
import window from './window';
export default class Store {
    static get instanceIdentifier() {
        return window.funwallet.instanceIdentifier;
    }
    static setInstanceIdentifier(value) {
        window.funwallet.instanceIdentifier = Helpers.deepClone(value);
    }
    static get userTrackingId() {
        return window.funwallet.userTrackingId;
    }
    static setUserTrackingId(value) {
        window.funwallet.userTrackingId = Helpers.deepClone(value);
    }
    static get url() {
        return window.funwallet.url;
    }
    static setUrl(value) {
        window.funwallet.url = Helpers.deepClone(value);
    }
    static get language() {
        if (window.funwallet.language) {
            return window.funwallet.language;
        }
        return 'en';
    }
    static setLanguage(value) {
        window.funwallet.language = value;
    }
    static get currentWalletRouter() {
        return window.funwallet.currentWalletRouter;
    }
    static setCurrentWalletRouter(value) {
        if (!value) {
            window.funwallet.currentWalletRouter = value;
            return;
        }
        window.funwallet.currentWalletRouter = Helpers.deepClone(value);
    }
    static get walletRouterUpdating() {
        if (window.funwallet.walletRouterUpdating) {
            return window.funwallet.walletRouterUpdating;
        }
        return false;
    }
    static setWalletRouterUpdating(value) {
        window.funwallet.walletRouterUpdating = Helpers.deepClone(value);
    }
    static get walletMobileNavHtml() {
        return window.funwallet.walletMobileNavHtml;
    }
    static setWalletMobileNavHtml(value) {
        window.funwallet.walletMobileNavHtml = value;
    }
    static get walletMobileNavInjectToClass() {
        return window.funwallet.walletMobileNavInjectToClass;
    }
    static setWalletMobileNavInjectToClass(value) {
        window.funwallet.walletMobileNavInjectToClass = value;
    }
    static get appId() {
        return window.funwallet.appId;
    }
    static setAppId(value) {
        window.funwallet.appId = Helpers.deepClone(value);
    }
    static get canAuthenticationBeIntegrated() {
        return window.funwallet.canAuthenticationBeIntegrated;
    }
    static setCanAuthenticationBeIntegrated(value) {
        window.funwallet.canAuthenticationBeIntegrated = Helpers.deepClone(value);
    }
}
//# sourceMappingURL=store.js.map